import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const oauthApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOauthApplications: builder.query({
      query: () => {
        return {
          url: "oauth/applications",
        };
      },
      providesTags: (result = [], error, arg) => [{ type: "Oauth", id: "index" }],
    }),
    createOauthApplication: builder.mutation({
      query: (application) => ({
        url: "oauth/applications",
        method: "POST",
        body: application,
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'Oauth', id: 'index' }],
    }),
    createOauthAuthorization: builder.mutation({
      query: (params) => ({
        url: "oauth/authorizations",
        method: "POST",
        body: params,
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'Oauth', id: 'index' }],
    }),
  }),
});

export const {
  useGetOauthApplicationsQuery,
  useCreateOauthApplicationMutation,
  useCreateOauthAuthorizationMutation
} = oauthApiSlice;
